/* eslint-disable */
export default {
  noRecords: 'Nenhum registo recente encontrado.',
  inBound: 'Recebida',
  outBound: 'Efetuada',
  missed: 'Chamada não atendida',
} as const;

// @key: @#@"noRecords"@#@ @source: @#@"No recent records found."@#@
// @key: @#@"inBound"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outBound"@#@ @source: @#@"Outbound"@#@
// @key: @#@"missed"@#@ @source: @#@"Missed Call"@#@
